module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "navbar-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "navbar navbar-inverse navbar-static-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse",
    attrs: {
      "id": "navbar"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    class: {
      active: _vm.activeClass === '/'
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeClass === '/places'
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/places'
    }
  }, [_vm._v("Places")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeClass === '/photos'
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/photos'
    }
  }, [_vm._v("Photos")])], 1), _vm._v(" "), _vm._m(1)])])])])])]), _vm._v(" "), _c('nav', [_c('router-view')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar",
      "aria-expanded": "false",
      "aria-controls": "navbar"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("McAnoy.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://mcanoy.github.io"
    }
  }, [_vm._v("Tech Things")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d718152","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 438
// module chunks = 1